export function hasValue(value: string[]) {
    return value.length > 0 && value.every(Boolean);
}
